<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: Search -->
    <b-dropdown
      size="sm"
      id="kt_quick_search_toggle"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1 tooltip_dash"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <img
              src="\images/nav_icon/serch1.svg"
              alt=""
              height="20px"
              width="20px"
            />
            <!-- <inline-svg src="media/svg/icons/General/Search.svg" /> -->
          </span>
          <span class="tooltiptext_dash">Search</span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <KTSearchDefault></KTSearchDefault>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Search -->

    <!--begin: Notifications -->
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary tooltip_dash"
          @click="notifications_read"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <!-- <inline-svg src="media/svg/icons/Code/Compiling.svg" /> -->
            <img
              src="\images/nav_icon/vertcal1.svg"
              alt=""
              height="20px"
              width="20px"
            />
            <sup class="text-danger" v-if="notifications_num != 0">{{
              notifications_num
            }}</sup>
          </span>
          <span class="pulse-ring"></span>
          <span class="tooltiptext_dash">Notifications</span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <KTDropdownNotification></KTDropdownNotification>
        </form>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Notifications -->

    <!--begin: Quick Actions -->
    <b-dropdown
      size="sm"
      class="d-none"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 tooltip_dash"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <img
              src="\images/nav_icon/line1.svg"
              alt=""
              height="20px"
              width="20px"
            />
          </span>
          <span class="tooltiptext_dash">Search</span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <KTDropdownQuickAction></KTDropdownQuickAction>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Quick Actions -->

    <!--begin: My Cart -->
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 tooltip_dash"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <img
              src="\images/nav_icon/shoping1.svg"
              alt=""
              height="20px"
              width="20px"
            />
          </span>
          <span class="tooltiptext_dash">My Cart</span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <KTDropdownMyCart></KTDropdownMyCart>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: My Cart -->

    <!--begin: Quick panel toggle -->
    <KTQuickPanel></KTQuickPanel>
    <!--end: Quick panel toggle -->

    <!--begin: Language bar -->
    <!-- <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
      >
        <template v-slot:button-content>
          <img class="h-20px w-20px rounded-sm" :src="pic" alt="" />
        </template>
        <b-dropdown-text tag="div" class="min-w-md-175px">
          <KTDropdownLanguage
            v-on:language-changed="onLanguageChanged"
          ></KTDropdownLanguage>
        </b-dropdown-text>
      </b-dropdown>
    </div> -->
    <!--end: Language bar -->

    <!--begin: User Bar -->
    <KTQuickUser :pic="pic"></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTSearchDefault from "@/view/layout/extras/dropdown/SearchDefault.vue";
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import KTDropdownQuickAction from "@/view/layout/extras/dropdown/DropdownQuickAction.vue";
import KTDropdownMyCart from "@/view/layout/extras/dropdown/DropdownMyCart.vue";
import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel.vue";
import i18nService from "@/core/services/i18n.service.js";
import GeneralService from "@/MainServices/GeneralService.js";
import { API_URL, MEDIA_URL } from "@/core/api";
import axios from "axios";

export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      notifications_num: 0,
      languages: i18nService.languages,
      mediaUrl: MEDIA_URL,
      user_id:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user")).id
          : null,
      user:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user"))
          : null,
      token: `Bearer ${localStorage.getItem("token")}`,
      pic: null,
    };
  },
  components: {
    KTSearchDefault,
    KTDropdownNotification,
    KTDropdownQuickAction,
    KTDropdownMyCart,
    KTDropdownLanguage,
    KTQuickUser,
    KTQuickPanel,
  },
  mounted() {
    window.Echo.channel("job_applied_channel").listen(
      "JobAppliedNotification",
      (e) => {
        if (e.auth_user_id == e.data.recruiter_id) {
          // replace 141 with e.auth_user_id in the if condition
          this.notifications_num += e.notifications_num;
        }

        // console.log(e);
      }
    );

    window.Echo.channel("channel").listen("Notifications", (e) => {
      this.notifications_num += e.total_unseen;
    });

    if (this.user.role == "Direct Employer") {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.get(`${API_URL}/recruiter-profile/${this.user_id}`).then((res) => {
        this.pic = this.mediaUrl + res.data.profile_pic;
        localStorage.setItem("profile", JSON.stringify(res.data));
      });
    } else {
      GeneralService.getSingleJobSeekerProfile(this.user_id).then((_res) => {
        this.pic = this.mediaUrl + _res.data.profile_pic;
        localStorage.setItem("profile", JSON.stringify(_res.data));
      });
    }
  },
  methods: {
    notifications_read() {
      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/notifications-read-status`).then((res) => {
        this.notifications_num = 0;
      });
    },

    onLanguageChanged() {
      this.languageFlag = this.languages.find((val) => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
  },
  computed: {
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  },
};
</script>
